import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  ogImage, 
  ogType = "website",
  structuredData 
}) => {
  const defaultTitle = "Drosh The Pod - Professional Podiatry Services Manchester";
  const defaultDescription = "Professional podiatry services in Manchester with home visits. Registered podiatrist providing foot care, foot pain treatment, nail treatment, fungal nail management, and corn and callus removal. Book your consultation today.";
  const defaultKeywords = "podiatry manchester, registered podiatrist, foot care manchester, foot pain treatment, nail treatment, fungal nail management, corn removal, callus removal, home visit podiatry, professional foot care";
  const defaultImage = "https://www.droshpod.com/logo512.2.png";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title || defaultTitle}</title>
      <meta name="title" content={title || defaultTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Medical/Health Compliance Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Drosh The Pod" />
      <meta name="language" content="en-GB" />
      <meta name="geo.region" content="GB-MAN" />
      <meta name="geo.placename" content="Manchester" />
      <meta name="geo.position" content="53.4808;-2.2426" />
      <meta name="ICBM" content="53.4808, -2.2426" />
      
      {/* Medical Professional Verification */}
      <meta name="medical-specialty" content="Podiatry" />
      <meta name="healthcare-provider" content="Registered Podiatrist" />
      <meta name="service-area" content="Manchester, Greater Manchester, UK" />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical || "https://www.droshpod.com/"} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:site_name" content="Drosh The Pod" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Drosh The Pod - Professional Podiatry Services" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical || "https://www.droshpod.com/"} />
      <meta property="twitter:title" content={title || defaultTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={ogImage || defaultImage} />
      <meta property="twitter:image:alt" content="Drosh The Pod - Professional Podiatry Services" />
      <meta property="twitter:site" content="@droshpod" />
      <meta property="twitter:creator" content="@droshpod" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead; 